<script setup lang="ts" generic="TType extends 'single' | 'multiple'">
import type { FormKitOptionsList } from "@formkit/inputs";
import { useRouteQuery } from "@vueuse/router";

type TValue = TType extends "single" ? string | null : string[] | null;

type Props = {
  uniqueName: string;
  type: TType;
  defaultValue?: TValue;
  options?: FormKitOptionsList;
  label?: string;
};

const {
  options = undefined,
  defaultValue = undefined,
  label = undefined,
  uniqueName,
  type: filterType,
} = defineProps<Props>();

const computedUniqueName = computed(() => uniqueName);
const defaultFilterValue = computed(() => {
  if (defaultValue) return defaultValue;

  return filterType === "single" ? undefined : [];
});

const queryFilterValue = useRouteQuery(
  computedUniqueName.value,
  defaultFilterValue.value,
  {
    transform: (value) => {
      if (filterType === "multiple" && !Array.isArray(value)) {
        return [value];
      }

      return value;
    },
  },
);

watch(queryFilterValue, (newValue, oldValue) => {
  if (oldValue && newValue !== oldValue) {
    window.scrollTo({
      top: 0,
    });
  }
});
</script>

<template>
  <div
    class="p-4 scroll-mt-16 md:scroll-mt-20"
    data-test="filter-section"
  >
    <BaseFilterExpandableInput
      v-model="queryFilterValue"
      :type="type === 'single' ? 'radio' : 'checkbox'"
      :label="label"
      :options="options"
    />
  </div>
</template>
